import {DropZone} from "@/components/ui/forms/DropZone";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

const UploadSection = ({title, description, accept, onUpload, maxFiles}) => (
  <div className={styles.upload}>
    <H3>
      <span dangerouslySetInnerHTML={{__html: title}} />
    </H3>

    <div className={styles.uploadDesc}>
      <RootDesc>
        <span dangerouslySetInnerHTML={{__html: description}} />
      </RootDesc>
    </div>

    <DropZone
      maxFiles={maxFiles}
      accept={accept}
      onUpload={onUpload}
      size={20 * 1024 * 1024}
      type={[".txt", ".pdf"]}
    />
  </div>
);

export const UploadFilePopup = ({
  level,
  fileList,
  setFileList,
  title,
  subtitle,
}) => {
  const {closePopup} = usePopup();
  const {t} = useTranslation();

  const handleUpload = (files) => {
    let updatedFileList = [];

    if (!files || files.length === 0) {
      console.log("Files is undefined!");

      return;
    }

    if (level) {
      updatedFileList = [...fileList, {level: level.value, file: files}];
    } else {
      updatedFileList = [...fileList, {file: files}];
    }

    setFileList(updatedFileList);
    closePopup();
  };

  const uploadConfig = {
    accept: {
      "text/plain": [".txt"],
      "application/pdf": [".pdf"],
    },
    onUpload: handleUpload,
  };

  if (level) {
    return (
      <UploadSection
        title={t("popup.upload_level_file.title", {level: {name: level.name}})}
        description={subtitle}
        {...uploadConfig}
        maxFiles={1}
      />
    );
  } else {
    return (
      <UploadSection
        {...uploadConfig}
        title={title}
        description={subtitle}
        maxFiles={0}
      />
    );
  }
};
